/**
 * Sets a cookie that can be accessed across subdomains of practist.io
 * This allows the public app (practist.io) to detect if a user is authenticated
 * on the firms app (firms.practist.io)
 */
export const setCrossDomainAuthCookie = (email: string) => {
  // Set cookie with domain=.practist.io so it's accessible on both
  // practist.io and firms.practist.io
  const expires = new Date();
  expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000); // 7 days

  // Note: For cookies to work across subdomains, we need domain=.practist.io
  // The Secure flag requires HTTPS (which both sites use)
  const cookieValue = `practist_auth_email=${encodeURIComponent(email)}; domain=.practist.io; path=/; expires=${expires.toUTCString()}; SameSite=Lax; Secure`;
  document.cookie = cookieValue;

  console.log('[crossDomainAuth] Set cookie:', cookieValue);
  console.log('[crossDomainAuth] All cookies:', document.cookie);
};

/**
 * Clears the cross-domain auth cookie
 */
export const clearCrossDomainAuthCookie = () => {
  document.cookie = `practist_auth_email=; domain=.practist.io; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; SameSite=Lax; Secure`;
};
